import * as React from "react";
import { observer } from "mobx-react";
import { ShowString } from "./ShowString";
import { VisibilityIcon } from "../../../icons";
import { IconButton } from "@mui/material";

export type ShowReferenceProps = {
  selectedValue: string;
  helperText?: string;
  label: string;
  icon?: React.ReactElement;
  onView?: () => void;
  compact?: boolean;
  hidden?: boolean;
  description?: string;
};

export const ShowReference: React.FC<ShowReferenceProps> = observer(
  ({
    selectedValue,
    helperText,
    label,
    onView,
    compact = false,
    hidden = false,
    description,
  }) => {
    if (hidden) return null;
    const sx = compact
      ? { m: 0, p: 0, color: "text.secondary" }
      : { ml: -3, color: "text.secondary" };
    return (
      <div style={{ display: "flex" }}>
        <ShowString
          label={label}
          value={selectedValue}
          helperText={helperText}
          description={description}
        />
        {onView && (
          <IconButton onClick={onView} sx={{ ...sx }}>
            <VisibilityIcon fontSize="small" />
          </IconButton>
        )}
      </div>
    );
  }
);
